import { render, staticRenderFns } from "./navList.vue?vue&type=template&id=45fc6c55&scoped=true&"
import script from "./navList.vue?vue&type=script&lang=js&"
export * from "./navList.vue?vue&type=script&lang=js&"
import style0 from "./navList.vue?vue&type=style&index=0&id=45fc6c55&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc6c55",
  null
  
)

export default component.exports